export function getPluralEnding(num, pluralEnding = "s", singularEnding = "") {
    return num === 1 ? singularEnding : pluralEnding;
}
